import React from 'react';
import { Button } from '@material-ui/core';
import { Buttons as ModalButtonsContainer } from './Modal.styles';
var ModalButtonType;
(function (ModalButtonType) {
    ModalButtonType["Confirm"] = "Confirm";
    ModalButtonType["Cancel"] = "Cancel";
})(ModalButtonType || (ModalButtonType = {}));
const ModalActionButtons = ({ showActionButtons, CancelButton, ConfirmButton, onClose, onConfirm, cancelButtonText = ModalButtonType.Cancel, confirmButtonText = ModalButtonType.Confirm, confirmButtonDisabled = false }) => {
    if (showActionButtons) {
        return (React.createElement(ModalButtonsContainer, null,
            CancelButton ? (React.createElement(CancelButton, null)) : (React.createElement(Button, { "aria-label": "modal cancel button", color: "primary", onClick: onClose }, cancelButtonText)),
            ConfirmButton ? (React.createElement(ConfirmButton, null)) : (React.createElement(Button, { "aria-label": "modal confirm button", color: "primary", variant: "contained", onClick: onConfirm, disabled: confirmButtonDisabled, disableElevation: true }, confirmButtonText))));
    }
    return null;
};
export default ModalActionButtons;
//# sourceMappingURL=ModalActionButtons.js.map